/**
 * Getters for wordpress/media module
 */
const getters = {
  all: state => state.media.filter(image => image.media_details.sizes.full),
  uploadPath: state => '/wp-json/wp/v2/media'
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/media/getters.js